import { styled } from '@abyss/web/tools/styled';
import { Button } from '@abyss/web/ui/Button';

export const StyledCloseButton = styled(Button, {
  '&.abyss-button-root': {
    margin: '0',
    width: '280px',

    '@screen < $sm': {
      margin: '18px 0 10px',
      width: '288px',
    },
  },
});
